import React from "react";
import { Link } from "react-router-dom"; // Import Link for navigation
import HeroImage from "../../../assets/photos/HeroImage.jpg";

const CareersHero = () => {
  return (
    <div
      className="relative h-screen bg-cover bg-center"
      style={{
        backgroundImage: `url(${HeroImage})`, // Fixed typo for dynamic image path
      }}
    >
      {/* Overlay for Dark Gradient Effect */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-black/70"></div>

      {/* Content */}
      <div className="relative flex flex-col justify-center items-start py-60 px-8 lg:px-24 text-white">
        <h1 className="text-4xl lg:text-6xl font-semibold mb-4">Careers</h1>
        <p className="text-lg lg:text-2xl mb-8">Let’s work together with CodeQueue</p>
        <Link to="/jobs">
          <button className="bg-white text-blue-900 font-bold px-6 py-3 flex items-center gap-2 shadow-md hover:bg-gray-100 transition duration-300">
            Explore our opportunities
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              />
            </svg>
          </button>
        </Link>
      </div>
    </div>
  );
};

export default CareersHero;
